import { ScorecardElements, ScorecardTypes } from '../Component/Model/Enum/BEE123Enums';
import { EmpowermentFinancingTransformationalInfrastructure } from '../Modules/BEEScorecards/EmpowermentFinancing/DataPages/EmpowermentFinancingTransformationalInfrastructure';
import { EmpowermentFinancingDashboard } from '../Modules/BEEScorecards/EmpowermentFinancing/EmpowermentFinancingDashboard';
import { EmpowermentFinancingDataPage } from '../Modules/BEEScorecards/EmpowermentFinancing/EmpowermentFinancingDataPage';
import { EmpowermentFinancingScorecard } from '../Modules/BEEScorecards/EmpowermentFinancing/EmpowermentFinancingScorecard';
import { TargetSettingsPage } from '../Modules/BEEScorecards/EmpowermentFinancing/TargetSettings/TargetSettingsPage';

export interface AdditionalNativeReactView {
    name: string;
    mini?: string;
    routeSegment: string;
    Component: any;
}

export interface DataPageTabConfig {
    label: string;
    route: string;
    Component?: any;
}

export interface NativeReactElementComponents {
    dashboard?: any;
    scorecard?: any;
    dataPage?: any;
    dataPageTabs?: DataPageTabConfig[];
    additionalViews?: AdditionalNativeReactView[];
}

const empowermentFinancingElementId = ScorecardElements['Empowering Financing And ESD'];

const reactPageScorecardTypeIdsByElementId: Record<number, number[]> = {
    [empowermentFinancingElementId]: [ScorecardTypes.Generic_Revised_FSC_Banks_Updated],
};

const reactPageElementsById: Record<number, () => NativeReactElementComponents> = {
    [empowermentFinancingElementId]: () => ({
        dashboard: EmpowermentFinancingDashboard,
        scorecard: EmpowermentFinancingScorecard,
        dataPage: EmpowermentFinancingDataPage,
        dataPageTabs: [
            { label: 'Transformational Infrastructure', route: 'transformationalInfrastructure', Component: EmpowermentFinancingTransformationalInfrastructure },
            { label: 'B-BBEE Agriculture Financing', route: 'bbbeeAgricultureFinancing' },
            { label: 'Affordable Housing', route: 'affordableHousing' },
            { label: 'B-BBEE Transactional Financing', route: 'bbbeeTransactionalFinancing' },
            { label: 'Black Business Growth Funding', route: 'blackBusinessGrowthFunding' },
            { label: 'BSME Non-fungible', route: 'bsmeNonFungible' },
        ],
        additionalViews: [
            {
                name: 'Target Settings',
                mini: 'TS',
                routeSegment: 'targetSettings',
                Component: TargetSettingsPage,
            },
        ],
    }),
};

export const getNativeReactElementComponents = (elementId?: number, scorecardTypeId?: number): NativeReactElementComponents | undefined => {
    if (elementId === undefined || scorecardTypeId === undefined) {
        return undefined;
    }

    const eligibleScorecardTypeIds = reactPageScorecardTypeIdsByElementId[elementId];
    if (!eligibleScorecardTypeIds || !eligibleScorecardTypeIds.includes(scorecardTypeId)) {
        return undefined;
    }

    return reactPageElementsById[elementId]?.();
};
